module.exports = __webpack_public_path__ + "static/media/5b_website_logo_diamond_anlev.73a01476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5b_website_logo_diamond_anlev.jpg
// module id = 86
// module chunks = 0